import { render, staticRenderFns } from "./DeptPickerConfig.vue?vue&type=template&id=a52e4358&scoped=true"
import script from "./DeptPickerConfig.vue?vue&type=script&lang=js"
export * from "./DeptPickerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52e4358",
  null
  
)

export default component.exports